const literal = <V extends keyof any>(v: V) => v;

export const Consts = {
    termsUrl: literal('assets/terms/ServiceTitan_-_Interim_Customer_Portal_Terms_11.1.2020.pdf'),
};
